var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 18.715V70c0 5.523-4.477 10-10 10H49.123c-11.731-5.47-16.867-17.202-17.581-28.366a26.138 26.138 0 01-.108-2.057c.027-.34.04-.68.055-1.029.013-.334.026-.674.053-1.028C32.516 32.288 41.72 16 64.677 16h.758c5.665 0 10.492.992 14.565 2.715z",
    fill: "#9B8CF9",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.184 67.596H55.68V41.038h12.146l-5.642 26.558z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86 67.596h-6.376V41.038H67.39l-5.53 26.558z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.092 24.998L24 32.328l2.805 10.08 26.092-7.33-2.805-10.08z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.967 25.19L24.31 32.397l2.714 9.757 25.657-7.207-2.715-9.757z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.693 32.046l-6.455 1.813.138.495 6.455-1.813-.138-.495zm.551 1.979l-6.455 1.813.138.495 6.455-1.813-.138-.495zm3.641-2.09L32.512 34.85l.137.495 10.373-2.914-.137-.495z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.141 37.027a1.2 1.2 0 00-.642-2.31 1.2 1.2 0 00.642 2.31z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.229 27.246l-25.51 9.543 3.684 9.943 25.51-9.543-3.684-9.943z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.036 27.616l-24.966 9.34 3.518 9.493 24.966-9.34-3.518-9.493z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.371 35.396l-6.281 2.35.178.482 6.282-2.35-.179-.482zm.715 1.924l-6.281 2.35.178.482 6.281-2.35-.178-.481zm3.594-2.382l-10.125 3.788.179.483 10.124-3.788-.179-.483z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.265 41.079a1.2 1.2 0 00.702-1.542 1.192 1.192 0 00-1.535-.705 1.2 1.2 0 00-.701 1.541c.23.62.917.937 1.534.706z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.269 33.997l-1.863 10.507 26.731 4.784L69 38.782l-26.731-4.785z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.624 38.94l-26.227-4.693-1.769 9.973 26.228 4.695 1.768-9.974z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.906 39.02l-.09.506 6.599 1.18.09-.505-6.599-1.181zm-.357 2.023l-.09.506 6.599 1.181.09-.505-6.6-1.182zm.177-1.011l-.09.506 10.605 1.898.09-.506-10.605-1.898z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.033 39.989a1.194 1.194 0 10-2.35-.42 1.194 1.194 0 102.35.42z",
    fill: "#B9AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.596 40.725l-4.39-3.089h-6.079v30.449h37.992v-27.36H34.596z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.761 41.037l-4.323-2.998h-5.985v29.557H61.86V41.037h-27.1z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.38 61.328a.451.451 0 01-.444.452h-19.56a.446.446 0 01-.444-.452V47.902a.45.45 0 01.444-.45h19.56a.446.446 0 01.445.45",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.152 61.11a.435.435 0 01-.432.433H33.612a.43.43 0 01-.432-.434V48.131a.435.435 0 01.431-.434h19.107a.43.43 0 01.431.434",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.861 48.297H34.485a.547.547 0 00-.545.548V60.44c0 .303.244.549.545.549h17.376a.547.547 0 00.546-.549V48.845a.547.547 0 00-.546-.548z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.614 48.606H34.712a.547.547 0 00-.546.549v10.929c0 .302.244.548.546.548h16.902a.547.547 0 00.546-.548V49.155a.547.547 0 00-.546-.549z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B9AFFB",
    strokeLinecap: "round",
    d: "M36.568 50.455h11.587m-11.587 2.596h8.138m1.519 4.498h1.931"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 61.753,
    y1: 67.596,
    x2: 61.753,
    y2: 41.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11803.2,
    y1: 2207.48,
    x2: 11546.9,
    y2: -776.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16283.7,
    y1: 4838.31,
    x2: 16283.7,
    y2: 1502.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9136.87,
    y1: 13324.8,
    x2: 9748.42,
    y2: 6548.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11801.5,
    y1: 21202.3,
    x2: 11801.5,
    y2: 6244.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 43.156,
    y1: 61.78,
    x2: 43.156,
    y2: 47.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 5773.71,
    y1: 7417.54,
    x2: 5773.71,
    y2: 4818.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24 25)",
    d: "M0 0h45v43.085H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 23,
    y: 25,
    width: 47,
    height: 45.085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.41242cbe80ce2d548f77505b44585d46.svg";
export { ForwardRef as ReactComponent };